import React from 'react';
type IconProps = {
  className?: string;
  title?: string;
};
const base = 'block';

/** Regulated electric utilities & power generation — transmission tower schematic. */
export function GridIcon({
  className = 'h-7 w-7',
  title
}: IconProps) {
  return <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.4} className={`${base} ${className}`} role="img" aria-label={title} aria-hidden={!title} data-id="element-19" data-mp="2x50wggmiz7ra">
      {title ? <title data-id="element-20" data-mp="3pr2gsvew2fvl">{title}</title> : null}
      <path d="M11 29 14.5 4h3L21 29" data-id="element-21" data-mp="3pteyr8kncq8n" />
      <path d="M8 12h16M6.5 18h19M5 24h22" data-id="element-22" data-mp="3ktk4cv1nxiiu" />
      <path d="M13 8h6" data-id="element-23" data-mp="3kulqbuk7vpfc" />
      <path d="M8 12 24 18M24 12 8 18" data-id="element-24" data-mp="3g1ivzk7m8by3" />
      <circle cx="16" cy="3" r="1.6" fill="currentColor" stroke="none" data-id="element-25" data-mp="3g0hjdbaybhe9" />
    </svg>;
}

/** Natural gas distribution — pipeline with flow valve. */
export function PipelineIcon({
  className = 'h-7 w-7',
  title
}: IconProps) {
  return <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.4} className={`${base} ${className}`} role="img" aria-label={title} aria-hidden={!title} data-id="element-26" data-mp="ceikzvgkucu6">
      {title ? <title data-id="element-27" data-mp="1vlxh5fwsdee2">{title}</title> : null}
      <path d="M2 10h9a4 4 0 0 1 4 4v4a4 4 0 0 0 4 4h11" data-id="element-28" data-mp="1zmpog3m3l97p" />
      <rect x="12.5" y="6.5" width="6" height="4" rx="1" data-id="element-29" data-mp="1zm7j8hhgjknn" />
      <path d="M15.5 10.5v3" data-id="element-30" data-mp="1lvubog8ha7yu" />
      <circle cx="24" cy="22" r="3" data-id="element-31" data-mp="1lut2yiexpxka" />
      <path d="M24 19v-4M20.5 26.5h7" data-id="element-32" data-mp="1lthw29q709oy" />
      <path d="M2 7.5v5M30 19.5v5" data-id="element-33" data-mp="1qtdrvloqkutf" />
    </svg>;
}

/** Enterprise technology & AI — neural node lattice. */
export function NeuralIcon({
  className = 'h-7 w-7',
  title
}: IconProps) {
  return <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.4} className={`${base} ${className}`} role="img" aria-label={title} aria-hidden={!title} data-id="element-34" data-mp="1gwhqs1163ayw">
      {title ? <title data-id="element-35" data-mp="17v9u1neaui6x">{title}</title> : null}
      <path d="M7 8 16 5l9 3M7 8v16l9 3 9-3V8M7 8l9 6 9-6M16 14v13" data-id="element-36" data-mp="17wck5t3ssgls" />
      <circle cx="16" cy="5" r="2.2" fill="currentColor" stroke="none" data-id="element-37" data-mp="2x9y8du6gaa7l" />
      <circle cx="7" cy="8" r="2" data-id="element-38" data-mp="2x8n5rxoqr8i2" />
      <circle cx="25" cy="8" r="2" data-id="element-39" data-mp="329udjwqvw7oq" />
      <circle cx="7" cy="24" r="2" data-id="element-40" data-mp="328szdjekn52s" />
      <circle cx="25" cy="24" r="2" data-id="element-41" data-mp="2zunthgcw4l14" />
      <circle cx="16" cy="14" r="2" data-id="element-42" data-mp="2zvyzlmtt64ve" />
    </svg>;
}

/** Cybersecurity — hardened shield with circuit trace. */
export function CyberShieldIcon({
  className = 'h-7 w-7',
  title
}: IconProps) {
  return <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.4} className={`${base} ${className}`} role="img" aria-label={title} aria-hidden={!title} data-id="element-43" data-mp="2qv0q4p0lp55f">
      {title ? <title data-id="element-44" data-mp="3jj6b9cvkgw5s">{title}</title> : null}
      <path d="M16 3 5.5 7v9c0 6.4 4.4 10.9 10.5 13 6.1-2.1 10.5-6.6 10.5-13V7L16 3Z" data-id="element-45" data-mp="3jidacsjah0vk" />
      <path d="M11 16h3l2-3.5 2 7 2-3.5h3" data-id="element-46" data-mp="3el4wv5935l0n" />
    </svg>;
}

/** Environmental & water infrastructure — reclaimed flow node. */
export function WaterIcon({
  className = 'h-7 w-7',
  title
}: IconProps) {
  return <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.4} className={`${base} ${className}`} role="img" aria-label={title} aria-hidden={!title} data-id="element-47" data-mp="34tqn84nf74ts">
      {title ? <title data-id="element-48" data-mp="1ci83sk2uj2r">{title}</title> : null}
      <path d="M16 3.5c4.2 5.4 6.5 9.1 6.5 12.2A6.5 6.5 0 0 1 16 22.2a6.5 6.5 0 0 1-6.5-6.5c0-3.1 2.3-6.8 6.5-12.2Z" data-id="element-49" data-mp="1b75vx6a5jdr" />
      <path d="M12.6 15.8c1.1-1.1 2.2-1.1 3.4 0 1.2 1.1 2.3 1.1 3.4 0" data-id="element-50" data-mp="dnjcq9mopboa" />
      <path d="M3 26c2.6-2 5.2-2 7.8 0s5.2 2 7.8 0 5.2-2 7.8 0" data-id="element-51" data-mp="dply2gcw6gmo" />
    </svg>;
}

/** Critical infrastructure & engineering — blueprint / structural set. */
export function BlueprintIcon({
  className = 'h-7 w-7',
  title
}: IconProps) {
  return <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.4} className={`${base} ${className}`} role="img" aria-label={title} aria-hidden={!title} data-id="element-52" data-mp="rnu3zdrwos9z">
      {title ? <title data-id="element-53" data-mp="11d3skjnjjstc">{title}</title> : null}
      <rect x="3.5" y="5.5" width="25" height="21" rx="1.5" data-id="element-54" data-mp="11e56cvvxyter" />
      <path d="M3.5 11h25M9 11v15.5M9 18h8.5M17.5 11v7" data-id="element-55" data-mp="16c6z68j6673f" />
      <path d="M21 15.5h4.5v7H21z" data-id="element-56" data-mp="16bnjkygzrusk" />
    </svg>;
}

/** SAP / cloud platform node. */
export function CloudNodeIcon({
  className = 'h-7 w-7',
  title
}: IconProps) {
  return <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth={1.4} className={`${base} ${className}`} role="img" aria-label={title} aria-hidden={!title} data-id="element-57" data-mp="1fdwrrhosfc2s">
      {title ? <title data-id="element-58" data-mp="2836m1wjghbzi">{title}</title> : null}
      <path d="M9 20a4.5 4.5 0 0 1 .6-9A6.6 6.6 0 0 1 22 11.6a4.7 4.7 0 0 1 1 9.3H9Z" data-id="element-59" data-mp="281vj1yxu489g" />
      <path d="M12 24.5h8M16 20.9v3.6" data-id="element-60" data-mp="2lt0bafyvhy9r" />
      <path d="M8 27.5h16" data-id="element-61" data-mp="2lw63i42stg9p" />
    </svg>;
}
export const industryMarks = [{
  key: 'electric',
  label: 'Regulated Electric & Generation',
  Icon: GridIcon
}, {
  key: 'gas',
  label: 'Natural Gas Distribution',
  Icon: PipelineIcon
}, {
  key: 'ai',
  label: 'Enterprise Technology & AI',
  Icon: NeuralIcon
}, {
  key: 'cyber',
  label: 'Cybersecurity & OT Resilience',
  Icon: CyberShieldIcon
}, {
  key: 'water',
  label: 'Environmental & Water Infrastructure',
  Icon: WaterIcon
}, {
  key: 'engineering',
  label: 'Critical Infrastructure Engineering',
  Icon: BlueprintIcon
}];